import styled, { css } from 'styled-components'
import theme from 'live/services/theme'

interface Props {
    width?: number
}

const ROW_HEIGHT = 40

export const Table = styled.table`
    position: relative;
    width: 100%;
    min-width: 100%;
`
export const Thead = styled.thead``
export const Tbody = styled.tbody``
export const Tfoot = styled.tfoot``
export const Tr = styled.tr`
    height: ${ROW_HEIGHT}px;
    border-bottom: 1px ${theme['gray-darker-bg']} solid;
`
export const Th = styled.th<Props>`
    ${({ width }) =>
        width
            ? css`
                  width: ${width}px;
              `
            : ''}
    min-width: 50px;
    position: sticky;
    top: 0;
    background: ${theme['dash-background']};
    color: ${theme['text-color']};
    padding: 5px 20px;
    white-space: nowrap;

    text-align: center;

    &.sheet {
        border-left: 1px ${theme['gray-darker-bg']} solid;
        border-right: 1px ${theme['gray-darker-bg']} solid;
    }
`
export const FixedFooter = styled.div`
    height: 40px;
    min-width: 50px;
    width: 100%;
    position: sticky;
    bottom: 0;
    background: ${theme['dash-background']};
    color: ${theme['text-color']};
    padding: 5px 20px;
    white-space: nowrap;

    text-align: center;
`
export const Tf = styled.th<Props>`
    ${({ width }) =>
        width
            ? css`
                  width: ${width}px;
              `
            : ''}
    min-width: 50px;
    position: sticky;
    bottom: 0;
    background: ${theme['dash-background']};
    color: ${theme['text-color']};
    padding: 5px 20px;
    white-space: nowrap;

    text-align: center;

    &.sheet {
        border-left: 1px ${theme['gray-darker-bg']} solid;
        border-right: 1px ${theme['gray-darker-bg']} solid;
    }
`
export const Td = styled.td<Props>`
    ${({ width }) =>
        width
            ? css`
                  width: ${width};
              `
            : ''}
    min-width: 50px;
    > div {
        width: 100%;
        height: ${ROW_HEIGHT}px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &.sheet {
        border-left: 1px ${theme['gray-darker-bg']} solid;
        border-right: 1px ${theme['gray-darker-bg']} solid;
        padding: 0;
    }
`

export const Container = styled.div<{ length: number }>`
    display: flex;
    height: ${({ length }) => ((length || 1) + 2) * (ROW_HEIGHT + 5)}px;
    max-height: 100%;
    width: 100%;

    .ScrollbarsCustom-Wrapper {
        inset: 0 !important;
    }

    .ScrollbarsCustom-TrackY {
        right: -10px !important;
    }
    .ScrollbarsCustom-TrackX {
        bottom: -10px !important;
    }
`
